import moment from 'moment';

export const getTimeAgo = (dateString) => {
  const timeAgo = moment(dateString).fromNow();
  return timeAgo;
}

export const getFormattedDate = (dateString, format) => {
  const date = moment(dateString).format(format);
  return date;
}

export const noAccess = () => {
  window.location.href = '/no-access';
}

export const maskName = (name) => {
  if (!name) return '';
  // const parts = name.split(" ");
  // return parts
  //     .map((part) => part[0] + "*".repeat(part.length - 1))
  //     .join(" ");
  return '* * * * * *'
};

export const toTitleCase = (str) => {
  if (!str) return '';
  return str
      .split('-') // Split the string into an array by '-'
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the array back into a single string with spaces
}

export const isEmptyArray = (arr) => {
  return Array.isArray(arr) && arr.length === 0;
}
